export default __webpack_public_path__ + "static/HomeBannerMob-19319ff7aff4febd6663128105c2fb7f.jpg";